import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-arrow-left\"><path style=\"fill:currentColor;fill-opacity:1;stroke:none;color:#4d4d4d\" d=\"M14.293 3 8.168 9.125 6.293 11l1.875 1.875L14.293 19l.707-.707-6.125-6.125L7.707 11l1.168-1.168L15 3.707 14.293 3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol